import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import type { PatientInfo } from '../types';

const accompanyingVisitorSlice = createSlice({
  initialState,
  name: 'AccompanyingVisitor',
  reducers: {
    resetPatientInfo: (state) => {
      state.patientInfo = initialState.patientInfo;
    },
    setPatientInfo: (state, action: PayloadAction<PatientInfo>) => {
      state.patientInfo = action.payload;
    },
  },
});

export const { actions: accompanyingVisitorAction } = accompanyingVisitorSlice;

export default accompanyingVisitorSlice.reducer;
